<template>
    <div class="m-block-text-read-more">
        <div :class="wrapperClasses" ref="wrapper" :style="wrapperStyles">
            <div :class="contentClasses" ref="content">
                <slot/>
            </div>
        </div>
        <div v-show="showReadMore" class="m-block-text-read-more__button" @click="toggle">
            <component :is="icon" color="primary"/>
            <e-link-inline>{{ toggleText }}</e-link-inline>
        </div>
    </div>
</template>

<script>
    export default {
        name: "m-block-text-read-more",
        data: () => ({
            showReadMore: false,
            expanded: false,
            wrapperHeight: '60px'
        }),
        props: {
            dots: {
                type: Boolean,
                default: true
            },
            collapseText: {
                type: Object,
                default: function () {
                    return {
                        more: this.$t('modules.accordions.m-accordion-collapse.more'),
                        less: this.$t('modules.accordions.m-accordion-collapse.less')
                    }
                }
            },
            visibleLines: {
                type: Number,
                default: 3
            }
        },
        mounted() {
            //define wrapper height
            this.calculateWrapperHeight();
            // define read more visibility
            if (parseFloat(this.wrapperHeight) < this.$refs.content.clientHeight) {
                this.showReadMore = true;
            }
        },
        computed: {
            icon() {
                return !this.expanded ? 'e-icon-expand-more' : 'e-icon-expand-less'
            },
            toggleText() {
                return !this.expanded ? this.collapseText.more : this.collapseText.less;
            },
            showDots() {
                return this.dots && !this.expanded && this.showReadMore
            },
            wrapperStyles() {
                return {
                    'max-height': this.wrapperHeight
                }
            },
            wrapperClasses() {
                return [
                    'm-block-text-read-more__wrapper',
                    {
                        'expanded': this.expanded,
                        'dots': this.showDots
                    }
                ]
            },
            contentClasses() {
                return [
                    'm-block-text-read-more__content',
                ]
            }
        },
        methods: {
            toggle() {
                this.expanded = !this.expanded
            },
            calculateWrapperHeight() {
                const lineHeight = getComputedStyle(this.$slots.default[0].elm).getPropertyValue('line-height');
                if (lineHeight) {
                    this.wrapperHeight = (this.visibleLines * parseFloat(lineHeight)) + 'px'
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .m-block-text-read-more {
        position: relative;

        &__wrapper {
            display: block;
            overflow: hidden;
            position: relative;

            &.expanded {
                max-height: none !important;
            }

            &.dots:after {
                content: "...";
                position: absolute;
                right: 0;
                padding: 0 50px 0 2px;
                bottom: 0px;
                background-color: #fff;
                font-size: 1.3rem;
                line-height: 1.75rem;
            }
        }

        &__content {
            height: auto;
        }

        &__button {
            position: absolute;
            right: 0;
            bottom: -35px;

            > i {
                line-height: 1.125rem;
            }
        }
    }

</style>
